<template>
  <div class="container">
    <div class="block mwow-form">
      <date-range-selector
        @change="handleDateRangeChange"
        style="margin-bottom: 0"
        :origin-data="dateRangeSelectorData"
      ></date-range-selector>
    </div>
    <div class="block">
      <div class="selfheader">
        <div style="font-size: 14px">综合数据</div>
      </div>
      <div
        class="datas"
        v-for="(item, index) in comprehensiveData"
        :key="index"
      >
        <div class="title">
          <p>
            {{ item.title }}
          </p>
          <el-popover
            placement="top"
            width="230"
            popper-class="followuppopover"
            trigger="hover"
          >
            <div class="tipck">
              <p v-for="(it, ind) in item.arr" :key="ind">{{ it.popover }}</p>
            </div>
            <div class="question" slot="reference">
              <div>?</div>
            </div>
          </el-popover>
        </div>
        <div class="data-item">
          <div
            :class="it.key === 'hover' ? 'item high-light' : 'item'"
            v-for="(it, ind) in item.arr"
            :key="ind"
            @click="goDetail(it)"
          >
            <div class="item-top">
              <p>{{ it.name }}</p>
            </div>
            <div class="item-bottom">{{ it.num }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <el-button
        class="mwow-button-filled primary btn-right"
        @click="handleExport"
        v-debounce="1000"
      >
        导出
      </el-button>
      <div class="block-title">
        数据明细
        <span class="select-time">
          查询时间: {{ currentTimeRange[0] + "~" + currentTimeRange[1] }}
        </span>
      </div>
      <div class="tabs">
        <div
          :class="checkTabs === 1 ? 'tabs-in p1 check-tabs' : 'tabs-in p1 '"
          @click="tabChange(1)"
        >
          学员明细
        </div>
        <div
          :class="checkTabs === 5 ? 'tabs-in p5 check-tabs' : 'tabs-in p5 '"
          @click="tabChange(5)"
        >
          老师明细
        </div>
        <div
          :class="checkTabs === 3 ? 'tabs-in p3 check-tabs' : 'tabs-in p3 '"
          @click="handleShowActivation"
        >
          活跃明细
        </div>
        <div
          :class="checkTabs === 4 ? 'tabs-in p4 check-tabs' : 'tabs-in p4 '"
          @click="handleShowCourseCost"
        >
          耗课分布
        </div>
        <div
          :class="checkTabs === 2 ? 'tabs-in p2 check-tabs' : 'tabs-in p2'"
          @click="tabChange(2)"
        >
          年龄分布
        </div>
      </div>
      <div v-show="checkTabs === 1">
        <el-button
          class="mwow-button-filled primary btn-right"
          @click="handleExport"
          v-debounce="5000"
        >
          导出
        </el-button>
        <common-search-form-wrapper :reset="resetSearch" :hiddenExpand="true">
          <el-form size="mini" :model="searchInfo">
            <el-row>
              <el-col :span="8">
                <el-form-item label="学员姓名:" prop="student_id">
                  <el-select
                    v-model="searchInfo.student_id"
                    clearable
                    filterable
                    placeholder="请选择"
                    @change="
                      () => {
                        handleSearch();
                        getSearchStudentList('');
                      }
                    "
                    :filter-method="getSearchStudentList"
                  >
                    <el-option
                      v-for="item in studentList"
                      :key="item.student_id"
                      :label="item.name"
                      :value="item.student_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="学员状态:" prop="student_status">
                  <el-select
                    v-model="searchInfo.student_status"
                    multiple
                    clearable
                    placeholder="请选择"
                    @change="handleSearch"
                  >
                    <el-option label="已删除" :value="-1"></el-option>
                    <el-option label="意向" :value="1"></el-option>
                    <el-option label="在读" :value="2"></el-option>
                    <el-option label="历史" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="耗课状态:" prop="consume_status">
                  <el-radio-group
                    v-model="searchInfo.consume_status"
                    @change="handleSearch"
                  >
                    <el-radio-button :label="-1">全部</el-radio-button>
                    <el-radio-button :label="1">已耗课</el-radio-button>
                    <el-radio-button :label="2">未耗课</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="超上状态:" prop="exceed_status">
                  <el-radio-group
                    v-model="searchInfo.exceed_status"
                    @change="handleSearch"
                  >
                    <el-radio-button :label="-1">全部</el-radio-button>
                    <el-radio-button :label="2">未超上</el-radio-button>
                    <el-radio-button :label="1">已超上</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="活跃状态:" prop="active_status">
                  <el-radio-group
                    v-model="searchInfo.active_status"
                    @change="handleSearch"
                  >
                    <el-radio-button :label="-1">全部</el-radio-button>
                    <el-radio-button :label="1">是</el-radio-button>
                    <el-radio-button :label="2">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="耗课种类:" prop="consume_class">
                  <el-select
                    v-model="searchInfo.consume_class"
                    multiple
                    placeholder="请选择"
                    @change="handleSearch"
                  >
                    <el-option label="1种" :value="1"></el-option>
                    <el-option label="2种" :value="2"></el-option>
                    <el-option label="2种以上" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </common-search-form-wrapper>
        <el-table
          :data="paginationData"
          v-horizontal-scroll
          stripe
          style="width: 100%"
          @sort-change="handleSortChange"
          :default-sort="{
            order: 'descending',
            prop: 'consume_amount',
          }"
        >
          <el-table-column prop="student.name" label="学员姓名">
          </el-table-column>
          <el-table-column label="学员状态">
            <template slot-scope="scope">
              <div v-if="scope.row.student.is_del === 1">已删除</div>
              <div
                v-else-if="
                  scope.row.student.is_del === 2 &&
                  scope.row.student.status === 1
                "
              >
                意向
              </div>
              <div
                v-else-if="
                  scope.row.student.is_del === 2 &&
                  scope.row.student.status === 2
                "
              >
                在读
              </div>
              <div
                v-else-if="
                  scope.row.student.is_del === 2 &&
                  scope.row.student.status === 3
                "
              >
                历史
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column label="耗课状态">
            <template slot-scope="scope">
              <div v-if="Number(scope.row.consume_number) > 0">已耗课</div>
              <div v-if="Number(scope.row.consume_number) === 0">未耗课</div>
            </template>
          </el-table-column>
          <el-table-column label="活跃状态">
            <template slot-scope="scope">
              <div v-if="Number(scope.row.consume_number) > 0">是</div>
              <div v-if="Number(scope.row.consume_number) === 0">否</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="roll_call_number"
            label="点名课次"
            min-width="100"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="consume_number"
            label="耗课数"
            min-width="100"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="consume_amount"
            label="课消金额(元)"
            min-width="130"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column prop="exceed_lesson" label="超上课时">
          </el-table-column>
          <el-table-column prop="consume_class" label="耗课种类">
          </el-table-column>
          <el-table-column
            prop="studentTime"
            label="入学时间"
            min-width="120"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot="header">
              <div class="selfheaders">
                <div>入学时间</div>
                <el-popover
                  placement="top"
                  popper-class="followuppopover"
                  trigger="hover"
                  width="133"
                >
                  <p class="tipck">首次缴费变为在读学员的时间</p>
                  <div class="question" slot="reference">
                    <div>?</div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="scope">
              <div>{{ getTime(scope.row.student.transform_time * 1000) }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div style="height: 60px">
          <el-pagination
            :current-page="page"
            :page-size="pageSize"
            :page-sizes="pageSizeArray"
            :style="{ float: 'right', padding: '20px' }"
            :total="total"
            @current-change="handlePagerChange"
            @size-change="handlePagerSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </div>
      <div v-show="checkTabs === 2">
        <el-button
          class="mwow-button-filled primary btn-right"
          @click="handleExport"
          v-debounce="5000"
        >
          导出
        </el-button>
        <div class="mwow-form">
          <el-radio-group
            v-model="currentShowType"
            size="mini"
            @change="showTypeChange"
          >
            <el-radio-button label="histogramChart">柱状图</el-radio-button>
            <el-radio-button label="pieChart">扇形图</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 柱状图 -->
        <div
          v-show="currentShowType === 'histogramChart'"
          id="histogramChart"
          class="chart-wrap"
        ></div>
        <!-- 饼状图 -->
        <div
          v-show="currentShowType === 'pieChart'"
          id="pieChart"
          class="chart-wrap"
        ></div>
      </div>
      <div v-show="checkTabs === 3">
        <activation :date-range="currentTimeRange"></activation>
      </div>
      <div v-show="checkTabs === 4">
        <course-cost></course-cost>
      </div>
      <div v-show="checkTabs === 5">
        <teacher-table :date-range="currentTimeRange"></teacher-table>
      </div>
    </div>
  </div>
</template>
<script>
// echart相关
import * as echarts from "echarts/core";
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import { BarChart, PieChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { LabelLayout } from "echarts/features";
import eventBus from "@/utils/bus";
echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
]);
echarts.use([GridComponent, BarChart, CanvasRenderer]);
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import {
  statisticsStudentComprehensiveApi,
  statisticsStudentDetailApi,
} from "@/api/statistics";
import { searchStudent } from "@/api/globalSearch";
import json2csv from "json2csv";
import { roundNumbers } from "@/utils/roundNumbers";
import dateRangeSelector from "@/view/teachManagement/studentManage/studyDetails/activation/dateRangeSelector.vue";
import activation from "./activation.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import courseCost from "./courseCost.vue";
import TeacherTable from "./teacherTable.vue";
export default {
  components: {
    TeacherTable,
    dateRangeSelector,
    activation,
    commonSearchFormWrapper,
    courseCost,
  },
  data() {
    return {
      dateRangeSelectorData: {
        rangeType: "",
        range: [],
        quick: "",
      }, // 时间段选择器初始数据，更改后会触发组件change
      searchInfo: {
        teacher_id: "",
        course_type: -1,
        consume_status: -1,
        roll_call_status: -1,
        exceed_status: -1,
        active_status: -1,
      },
      currentTimeRange: [],
      comprehensiveData: [],
      studentList: [],
      choiceDate0: "",
      tableData: [],
      currentSortOption: {
        order: "descending",
        prop: "consume_amount",
      },
      paginationData: [],
      myChart: {},
      resizeMark: false,
      currentShowType: "histogramChart",
      page: 1,
      pageSize: 30,
      pageSizeArray: [30, 50, 100],
      total: 0,
      checkTabs: 1,
      chartAgeGroup: [0, 0, 0, 0, 0, 0, 0, 0], // 学生年龄数据
      enterDateOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = "";
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 11
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 11
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          const max = newDate < maxTime ? newDate : maxTime;
          //如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          //若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        },
      },
    };
  },
  created() {
    this.getSearchStudentList("");
  },
  mounted() {
    const chartDom = document.getElementById("histogramChart");
    this.myChart = echarts.init(chartDom);
    window.addEventListener("resize", () => {
      if (this.resizeMark) {
        return false;
      }
      this.resizeMark = true;
      setTimeout(() => {
        this.myChart.resize();
        this.resizeMark = false;
      }, 1000);
    });
    // 监听“耗课分布”跳转“活跃明细”
    eventBus.$on("student-statistics-cost-navigate-to-activation", (data) => {
      // 页面切到活跃明细
      this.tabChange(3);
      // 触发顶部时间组件更新
      let start = data.month + "-01";
      let end = dateFormat("YYYY-mm-dd", getCurrentMonth(start)[1]);
      this.dateRangeSelectorData = {
        rangeType: "month",
        range: [start, end],
        quick: "",
      };
    });
  },
  methods: {
    showTypeChange(type) {
      const chartDom = document.getElementById(this.currentShowType);
      this.myChart = echarts.init(chartDom);
      this.currentShowType = type;
      this.chartRender();
      setTimeout(() => {
        this.myChart.resize();
        this.resizeMark = false;
      }, 1);
    },
    tabChange(val) {
      this.checkTabs = val;
      if (this.checkTabs === 2) {
        setTimeout(() => {
          this.myChart.resize();
          this.resizeMark = false;
        }, 1);
      }
    },
    goDetail(val) {
      if (val.key === "") {
        return false;
      }
      if (val.name === "未活跃学员") {
        this.checkTabs = 1;
        this.searchInfo.active_status = 2;
        setTimeout(() => {
          const el = document.getElementById("layout-content");
          el.scrollTop = 320;
        }, 1);
        this.handleDateRangeChange();
      } else {
        this.$router.push({
          name: "graduationStudent",
          query: {
            start_time: this.currentTimeRange[0],
            end_time: this.currentTimeRange[1],
          },
        });
      }
    },
    getTime(val) {
      const time = dateFormat("YYYY-mm-dd", val);
      return time;
    },
    getSearchStudentList(v) {
      searchStudent({
        page: 1,
        page_size: 1000,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getList({
        start_date: this.currentTimeRange[0],
        end_date: this.currentTimeRange[1],
      });
    },
    resetSearch() {
      this.searchInfo = {
        date: [],
        range: "month",
        teacher_id: "",
        course_type: -1,
        consume_status: -1,
        roll_call_status: -1,
        exceed_status: -1,
        active_status: -1,
      };
      this.handleDateRangeChange();
    },
    getComprehensiveData(val) {
      statisticsStudentComprehensiveApi(val).then((res) => {
        if (res.error_code === 0) {
          this.comprehensiveData = [];
          const studentArr = {
            title: "学员数据",
            arr: [
              {
                name: "门店学员",
                popover: "门店学员: 查询时间段内属于过在读状态的学员人数",
                num: res.data.center_student_total,
                route_name: "",
                key: "",
              },
              {
                name: "活跃学员",
                popover: "活跃学员: 所选时间段内有耗课数的学员",
                num: res.data.active_student_total,
                route_name: "",
                key: "",
              },
              {
                name: "未活跃学员",
                popover: "未活跃学员: 所选时间段内没有耗课数的学员",
                num: res.data.inactive_student_total,
                route_name: "",
                key: "hover",
              },
              {
                name: "活跃率",
                popover: "活跃率: 活跃率 = 活跃学员 / 门店学员 * 100%",
                num: roundNumbers(res.data.active_student_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "结业学员",
                popover: "结业学员: 所选时间段内，结业转化为历史的学员数",
                num: res.data.graduation_student_total,
                route_name: "",
                key: "hover",
              },
              {
                name: "学员平均科目",
                popover: `学员平均科目数: 学员科目数之和（A学员科目数+B学员科目数...）/ 学员数`,
                num: res.data.avg_subject,
                route_name: "",
                key: "",
              },
            ],
          };
          const consumeArr = {
            title: "阶段数据",
            arr: [
              {
                name: "周耗2课时及以上学员",
                popover: "周耗2课时及以上学员: 周耗2课时及以上的学员数",
                num: res.data.week_consume_two_student_total,
                route_name: "",
                key: "",
              },
              {
                name: "周耗2课时及以上占比",
                popover:
                  "周耗2课时及以上占比: 周耗2课时及以上占比 = 周耗2课时及以上学员 / 门店学员 * 100%",
                num: roundNumbers(res.data.week_consume_two_student_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "耗2种及以上科目学员",
                popover: "耗2种及以上科目学员: 耗2种及以上科目的学员数",
                num: res.data.week_consume_two_subject_total,
                route_name: "",
                key: "",
              },
              {
                name: "耗2种及以上科目占比",
                popover:
                  "耗2种及以上科目占比: 耗2种及以上科目占比 = 耗2种及以上科目学员 / 门店学员 * 100%",
                num: roundNumbers(res.data.week_consume_two_subject_rate) + "%",
                route_name: "",
                key: "",
              },
            ],
          };
          const beginStudentArr = {
            title: "期初学员数据",
            arr: [
              {
                name: "期初在读学员数",
                popover: "查询开始日期零点的在读学员人数，按学员去重；",
                num: res.data.begin_student_data.ongoing_student_num,
                route_name: "",
                key: "",
              },
              {
                name: "活跃人数",
                popover:
                  "期初在读学员，在查询时间内有耗课的学员数，按学员去重；",
                num: res.data.begin_student_data.active_student_num,
                route_name: "",
                key: "",
              },
              {
                name: "活跃率",
                popover: "活跃率=活跃人数/期初在读学员数*100%",
                num:
                  roundNumbers(res.data.begin_student_data.active_rate) + "%",
                route_name: "",
                key: "",
              },
            ],
          };
          this.comprehensiveData.push(studentArr, consumeArr, beginStudentArr);
        }
      });
    },
    chartRender() {
      let option = {};
      let self = this;
      if (self.currentShowType === "histogramChart") {
        option = {
          tooltip: {
            trigger: "axis",
            formatter: "{a} <br/>{b} : {c}人",
          },
          xAxis: {
            type: "category",
            data: [
              `在读学员数 \n\n（${self.chartAgeGroup[0]}人）\n\n 1~3岁`,
              `在读学员数 \n\n（${self.chartAgeGroup[1]}人）\n\n 4~6岁`,
              `在读学员数 \n\n（${self.chartAgeGroup[2]}人）\n\n 7~9岁`,
              `在读学员数 \n\n（${self.chartAgeGroup[3]}人）\n\n 10~12岁`,
              `在读学员数 \n\n（${self.chartAgeGroup[4]}人）\n\n 13~15岁`,
              `在读学员数 \n\n（${self.chartAgeGroup[5]}人）\n\n 16~18岁`,
              `在读学员数 \n\n（${self.chartAgeGroup[6]}人）\n\n 19~100岁`,
              `在读学员数 \n\n（${self.chartAgeGroup[7]}人）\n\n 暂无年龄段`,
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              color: "#07d1aa",
              name: "在读学员数",
              type: "bar",
              data: [
                { value: self.chartAgeGroup[0], name: `1~3岁` },
                { value: self.chartAgeGroup[1], name: `4~6岁` },
                { value: self.chartAgeGroup[2], name: `7~9岁` },
                { value: self.chartAgeGroup[3], name: `10~12岁` },
                { value: self.chartAgeGroup[4], name: `13~15岁` },
                { value: self.chartAgeGroup[5], name: `16~18岁` },
                { value: self.chartAgeGroup[6], name: `19~100岁` },
                { value: self.chartAgeGroup[7], name: `暂无年龄段` },
              ],
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    let percentage = 0;
                    const num =
                      self.chartAgeGroup[0] +
                      self.chartAgeGroup[1] +
                      self.chartAgeGroup[2] +
                      self.chartAgeGroup[3] +
                      self.chartAgeGroup[4] +
                      self.chartAgeGroup[5] +
                      self.chartAgeGroup[6] +
                      self.chartAgeGroup[7];
                    if (num === 0) {
                      percentage = 0;
                    } else {
                      percentage = (params.value / num) * 100;
                    }
                    //标签内容
                    return `${
                      percentage.toFixed(2) === "0.00"
                        ? 0
                        : percentage.toFixed(2)
                    } %`;
                  },
                  position: "top",
                  fontSize: 10,
                  color: "#6e7079",
                },
              },
            },
          ],
        };
      } else if (self.currentShowType === "pieChart") {
        const legendDataList = [];
        legendDataList.push("1~3岁");
        legendDataList.push("4~6岁");
        legendDataList.push("7~9岁");
        legendDataList.push("10~12岁");
        legendDataList.push("13~15岁");
        legendDataList.push("16~18岁");
        legendDataList.push("19~100岁");
        legendDataList.push("暂无年龄段");
        option = {
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}人 [{d}%]",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 60,
            data: legendDataList,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          series: [
            {
              name: "在读学员数",
              type: "pie",
              radius: ["40%", "70%"],
              data: [
                { value: self.chartAgeGroup[0], name: `1~3岁` },
                { value: self.chartAgeGroup[1], name: `4~6岁` },
                { value: self.chartAgeGroup[2], name: `7~9岁` },
                { value: self.chartAgeGroup[3], name: `10~12岁` },
                { value: self.chartAgeGroup[4], name: `13~15岁` },
                { value: self.chartAgeGroup[5], name: `16~18岁` },
                { value: self.chartAgeGroup[6], name: `19~100岁` },
                { value: self.chartAgeGroup[7], name: `暂无年龄段` },
              ],
              label: {
                normal: {
                  show: false,
                  formatter: "{b} : {c} ({d}%)",
                },
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      }
      option &&
        self.myChart.setOption(option, {
          notMerge: true,
        });
    },
    getList(val) {
      const data = {
        start_date: val.start_date,
        end_date: val.end_date,
      };
      const v = this.searchInfo;
      if (v.student_id) {
        data.student_id = v.student_id;
      }
      if (v.student_status) {
        data.student_status = v.student_status;
      }
      if (v.consume_status > 0) {
        data.consume_status = v.consume_status;
      }
      if (v.roll_call_status > 0) {
        data.roll_call_status = v.roll_call_status;
      }
      if (v.exceed_status > 0) {
        data.exceed_status = v.exceed_status;
      }
      if (v.consume_class) {
        data.consume_class = v.consume_class;
      }
      if (v.active_status > 0) {
        data.active_status = v.active_status;
      }
      statisticsStudentDetailApi(data).then((res) => {
        if (res.error_code === 0) {
          // 学生年龄段人数统计
          let ageGroup1 = 0;
          let ageGroup2 = 0;
          let ageGroup3 = 0;
          let ageGroup4 = 0;
          let ageGroup5 = 0;
          let ageGroup6 = 0;
          let ageGroup7 = 0;
          let ageGroup8 = 0;
          res.data.list.map((item) => {
            item.studentTime = item.student.transform_time;
            item.consume_number = roundNumbers(item.consume_number);
            item.consume_amount = roundNumbers(item.consume_amount);
            item.exceed_lesson = roundNumbers(item.exceed_lesson);
            if (item.student.age >= 1 && item.student.age <= 3) {
              ageGroup1++;
            } else if (item.student.age >= 4 && item.student.age <= 6) {
              ageGroup2++;
            } else if (item.student.age >= 7 && item.student.age <= 9) {
              ageGroup3++;
            } else if (item.student.age >= 10 && item.student.age <= 12) {
              ageGroup4++;
            } else if (item.student.age >= 13 && item.student.age <= 15) {
              ageGroup5++;
            } else if (item.student.age >= 16 && item.student.age <= 18) {
              ageGroup6++;
            } else if (item.student.age >= 19 && item.student.age <= 100) {
              ageGroup7++;
            } else if (item.student.age === 0) {
              ageGroup8++;
            }
          });
          this.tableData = res.data.list;
          this.total = res.data.list.length;
          this.page = 1;
          this.handleSortChange({
            order: this.currentSortOption.order,
            prop: this.currentSortOption.prop,
          });
          this.pageList({ page: this.page, page_size: this.pageSize });
          this.chartAgeGroup = [
            ageGroup1,
            ageGroup2,
            ageGroup3,
            ageGroup4,
            ageGroup5,
            ageGroup6,
            ageGroup7,
            ageGroup8,
          ];
          this.chartRender();
        }
      });
    },
    // 导出
    handleExport() {
      const dateArr = JSON.parse(JSON.stringify(this.tableData));
      dateArr.map((it) => {
        if (it.student.is_del === 1) {
          it.student.is_del = "已删除";
        } else if (it.student.is_del === 2 && it.student.status === 1) {
          it.student.is_del = "意向";
        } else if (it.student.is_del === 2 && it.student.status === 2) {
          it.student.is_del = "在读";
        } else if (it.student.is_del === 2 && it.student.status === 3) {
          it.student.is_del = "历史";
        }
        it.consume_haoKe = it.consume_number > 0 ? "已耗课" : "未耗课";
        it.studentTime = this.getTime(it.student.transform_time * 1000);
      });
      const date = new Date().getTime();
      const dateTime = dateFormat("YYYYmmddHHMMSS", date);
      const endThree = String(date).slice(-3, date.length);
      try {
        const result = json2csv.parse(
          [
            {
              "student.name": "学员姓名",
              "student.is_del": "学员状态",
              consume_haoKe: "耗课状态",
              roll_call_number: "点名课次",
              consume_number: "耗课数",
              consume_amount: "课消金额(元)",
              exceed_lesson: "超上课时",
              consume_class: "耗课种类",
              studentTime: "入学时间",
            },
            ...dateArr,
          ],
          {
            fields: [
              "student.name",
              "student.is_del",
              "consume_haoKe",
              "roll_call_number",
              "consume_number",
              "consume_amount",
              "exceed_lesson",
              "consume_class",
              "studentTime",
            ],
            header: false,
          }
        );
        // 非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        // 创建a标签下载
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = "学员数据" + dateTime + endThree;
        (".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
    handleSortChange(val) {
      this.currentSortOption = {
        order: val.order,
        prop: val.prop,
      };
      this.tableData = this.sortList(this.tableData);
      this.pageList({ page: this.page, page_size: this.pageSize });
    },
    sortList(val) {
      const copy = [...val];
      copy.sort((a, b) => {
        return (
          Number(b[this.currentSortOption.prop]) -
          Number(a[this.currentSortOption.prop])
        );
      });
      copy.map((it, ind) => {
        it.ind = ind + 1;
      });
      if (this.currentSortOption.order === "ascending") {
        copy.reverse();
      }
      return copy;
    },
    // 分页
    pageList(params) {
      const all = [...this.tableData];
      this.paginationData = all.slice(
        (params.page - 1) * params.page_size,
        (params.page - 1) * params.page_size + params.page_size
      );
      this.page = params.page;
      this.pageSize = params.page_size;
    },
    handlePagerChange(e) {
      this.page = e;
      this.pageList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.pageList({
        page: 1,
        page_size: e,
      });
    },
    handleDateRangeChange(data) {
      let arr = [];
      if (data && data.dates && data.dates.length === 2) {
        arr = data.dates;
        this.currentTimeRange = data.dates;
        eventBus.$emit("student-statistics-change-date-range-type", data.type);
      } else {
        arr = this.currentTimeRange;
      }
      this.getComprehensiveData({
        start_date: arr[0],
        end_date: arr[1],
      });
      this.getList({
        start_date: arr[0],
        end_date: arr[1],
      });
    },
    handleShowActivation() {
      eventBus.$emit("student-statistics-show-activation");
      this.tabChange(3);
    },
    handleShowCourseCost() {
      eventBus.$emit("student-statistics-show-course-cost");
      this.tabChange(4);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  .block {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 12px;
    padding: 15px 12px;
    position: relative;
    .btn-right {
      position: absolute;
      right: 20px;
      top: 12px;
      z-index: 100;
    }
    .searchTime {
      margin-bottom: 0 !important;
    }
    .radio-group {
      display: inline-block;
      .mwow-button {
        margin-left: 12px;
      }
    }
    .block-title {
      margin-bottom: 16px;
      font-size: 14px;
      color: #5c5d5e;
      font-weight: bold;
      .select-time {
        margin-left: 18px;
        color: #ffb940;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .total-wrap {
      display: flex;
      .item {
        padding: 16px 0 16px 3%;
        flex: 1;
        border: 1px solid #e7e8ea;
        border-right: 0;
        cursor: pointer;
        &.high-light {
          &:hover {
            border-color: #07d1aa !important;
            & + .item {
              border-left: 1px solid #07d1aa !important;
            }
          }
        }
        &:last-child {
          border-right: 1px solid #e7e8ea;
        }
        &:first-child {
          cursor: default;
        }
        p {
          font-size: 12px;
          color: #5c5d5e;
          line-height: 28px;
          display: flex;
          align-items: center;
          img {
            margin-left: 10px;
          }
        }
        .number {
          font-size: 26px;
          font-weight: bold;
          line-height: 42px;
        }
      }
    }
    .show-wrap {
      padding-bottom: 12px;
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .el-radio-group {
          margin-left: 18px;
        }
        .label {
          font-size: 14px;
          color: #5c5d5e;
          font-weight: bold;
        }
        .center {
          flex: 1;
        }
        .right {
          display: inline-flex;
          align-items: center;
        }
      }
    }
    .chart-wrap {
      height: 350px;
    }
    .selfheader {
      color: #5c5d5e;
      display: flex;
      align-items: center;
    }
    .datas {
      color: #5c5d5e;
      margin: 10px 0;
      .title {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-bottom: 10px;
        width: 100px;
      }
      .data-item {
        flex: 1;
        height: 55px;
        width: 100%;
        display: flex;
        .item {
          padding: 10px;
          text-align: center;
          box-sizing: border-box;
          min-width: 103px;
          background: #f6fafc;
          border-right: 1px solid #f1f2f2;
          &:last-child {
            border-right: none;
          }
          .item-top {
            margin-bottom: 5px;
            font-size: 12px;
          }
          .item-bottom {
            font-size: 18px;
            font-weight: 700;
          }
          &.high-light {
            cursor: pointer;
            &:hover {
              border: 1px solid #07d1aa !important;
              background: #f0fdfa !important;
            }
          }
        }
      }
    }
  }
  /deep/.form {
    .el-form-item {
      display: flex;
      .el-form-item__label {
        min-width: 80px !important;
        text-align: right;
      }
      .el-form-item__content {
        width: 100%;
      }
    }
  }
}
.selfheaders {
  display: inline-flex;
  align-items: center;
  .question {
    margin-left: 5px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #bebfc0;
    text-align: center;
    line-height: 16px;
    opacity: 1;
    color: #fff;
    font-size: 10px;
  }
}
.tabs {
  display: flex;
  margin-bottom: 15px;
  margin-top: 15px;
  .tabs-in {
    border: 1px solid #c0c7ce;
    color: #5c5d5e;
    padding: 5px 15px;
    cursor: pointer;
    border-right: 0;
    &:last-child {
      border-right: 1px solid #c0c7ce;
    }
  }
  .p1 {
    border-radius: 3px 0 0 3px;
  }
  .p2 {
    border-radius: 0 3px 3px 0;
  }
}
.check-tabs {
  border-color: #07d1aa !important;
  color: #07d1aa !important;
  & + .tabs-in {
    border-left: 1px solid #07d1aa !important;
  }
}
</style>
